<div class="viewer-container">

  <div class="viewer-header">
    <h3>Document Viewer</h3>
    <button mat-icon-button (click)="closeDialog()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="viewer-body">

    <div *ngIf="loading()" class="viewer-loader">
      <mat-spinner diameter="50"></mat-spinner>
    </div>

    <div *ngIf="pdfSrc" class="pdf-viewer-wrapper" [class.hidden-content]="loading()">
      <ngx-extended-pdf-viewer
        [src]="pdfSrc"
        [height]="'100%'"
        [textLayer]="true"
        [showSidebarButton]="true"
        [showFindButton]="true"
        [showPagingButtons]="true"
        [showZoomButtons]="true"
        [showPresentationModeButton]="true"
        [showOpenFileButton]="false"
        [showPrintButton]="true"
        [showDownloadButton]="true"
        [showSecondaryToolbarButton]="true"
        [zoom]="'auto'"
        (pagesLoaded)="onPdfPageLoaded($event)">
      </ngx-extended-pdf-viewer>
    </div>

    <div *ngIf="imageSrc" class="image-section" [class.hidden-content]="loading()">
      <div class="image-toolbar">
        <button mat-icon-button (click)="zoomIn()" matTooltip="Zoom In">
          <mat-icon>zoom_in</mat-icon>
        </button>
        <button mat-icon-button (click)="zoomOut()" matTooltip="Zoom Out">
          <mat-icon>zoom_out</mat-icon>
        </button>
        <button mat-icon-button (click)="fitToScreen()" matTooltip="Reset View">
          <mat-icon>fit_screen</mat-icon>
        </button>
        
        <div style="width: 1px; height: 24px; background: rgba(255,255,255,0.3); margin: 0 4px;"></div>
        
        <button mat-icon-button (click)="rotateLeft()" matTooltip="Rotate Left">
          <mat-icon>rotate_left</mat-icon>
        </button>
        <button mat-icon-button (click)="rotateRight()" matTooltip="Rotate Right">
          <mat-icon>rotate_right</mat-icon>
        </button>

        <div style="width: 1px; height: 24px; background: rgba(255,255,255,0.3); margin: 0 4px;"></div>

        <button mat-icon-button (click)="downloadImage()" matTooltip="Download">
          <mat-icon>download</mat-icon>
        </button>
        <button mat-icon-button (click)="printImage()" matTooltip="Print">
          <mat-icon>print</mat-icon>
        </button>
      </div>

      <div class="image-preview-container">
        <img 
          [src]="imageSrc"
          class="image-fit"
          [style.transform]="'scale(' + zoomLevel + ') rotate(' + rotation + 'deg)'"
          alt="Document Preview"
          (load)="onImageLoaded()"
          (error)="onErrorLoading()"
        />
      </div>
    </div>

    <div *ngIf="!loading() && !pdfSrc && !imageSrc" class="no-preview">
      <mat-icon>description</mat-icon>
      <p>Preview not available for this file type.</p>
      <button mat-stroked-button (click)="closeDialog()">Close Viewer</button>
    </div>

  </div>
</div>